import apiDtMood from './dtMoodApiHandler'
import { getDtMoodSession } from './dtmood-session.service'

const getInteractionsLog = () => {
  const dtMoodSession = getDtMoodSession()
  const userId = dtMoodSession ? dtMoodSession.userId : ''

  return new Promise((resolve, reject) => {
    apiDtMood
      .get(`/interactions-logs/list/?userId=${userId}&limit=10`)
      .then((res) => {
        resolve(res.data)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export { getInteractionsLog }
